/**
 * Keep in sync with qcenter App\Support\DeviceOnlineTiming.
 */
export const CYCLE_MS = 30000;
export const HEARTBEAT_INTERVAL_MS = 15000;
export const ACTIVITY_GRACE_MS = CYCLE_MS;
export const NOTIFICATION_DEDUP_WINDOW_MS = HEARTBEAT_INTERVAL_MS * 4;
